import { genVr } from "../../core/utils";
import { BaseEntity, EntityIndex, ModelEntity, ParentEntity } from "../../core/baseEntity.model";
import { AuthService } from "../core-services/auth.service";
import { AppointmentTrait } from "./appointment.entity";

export interface AppointmentDayTrait {
    id: string;
    appointments: AppointmentTrait[];
    createdAt: number;
}

@ModelEntity("appointment-days")
export class AppointmentDayEntity extends BaseEntity<AppointmentDayEntity> implements AppointmentDayTrait {
    @ParentEntity("users", () => AuthService.instance.currentUser?.uid)
    public userId: string;

    constructor(
        public id: string,
        public appointments: AppointmentTrait[] = [],
        public createdAt: number = Date.now(),
        public version: string = genVr()
    ) {
        super();
    }

    static async loadAll<C extends BaseEntity<C>>(id: string = AuthService.instance?.currentUser?.uid, {parentName, offset, ignoreStorageDbData, orderBy}: {parentName?: string; offset?: string; ignoreStorageDbData?: boolean; orderBy?: {
        column: keyof C;
        sort: 'asc' | 'desc'
    }} = {parentName: 'users'}): Promise<C[]> {
        super.setParent('users', id);
        return super.loadAll(id, {parentName: parentName || 'users', offset, orderBy, ignoreStorageDbData: ignoreStorageDbData || true});
    }

    static async persistMany<T = AppointmentDayEntity>(data: T[]): Promise<boolean> {
        const id = AuthService.instance?.currentUser?.uid;
        super.setParent('users', id);
        return super.persistMany<T>(data, id)
    }  
    public export<T = AppointmentDayTrait>(): T {
        return {
            id: this.id,
            version: this.version,
            appointments: this.appointments,
            createdAt: this.createdAt,
        } as any;
    }
}